import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Guthaben", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = {
  key: 1,
  style: {"margin-left":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Hide = _resolveComponent("Hide")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_dialog, {
      modelValue: this.isChargeCreditDialogOpened,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.isChargeCreditDialogOpened) = $event)),
      title: "Administration",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.isChargeCreditDialogOpened = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Abbrechen")
            ]),
            _: 1
          }),
          (this.addBalance)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "success",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (this.chargeCredit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Aufladen ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "danger",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (this.chargeCredit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Entfernen ")
                ]),
                _: 1
              }))
        ])
      ]),
      default: _withCtx(() => [
        (this.addBalance)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Guthaben hinzufügen"))
          : (_openBlock(), _createElementBlock("h3", _hoisted_4, "Guthaben entfernen")),
        _createElementVNode("div", null, "Ausgewählter Nutzer: " + _toDisplayString(this.selectedUser.firstName) + " " + _toDisplayString(this.selectedUser.lastName), 1),
        (this.addBalance)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Bitte wählen Sie einen Betrag zum aufladen."))
          : (_openBlock(), _createElementBlock("p", _hoisted_6, "Bitte wählen Sie einen Betrag zum entfernen.")),
        _createVNode(_component_el_input_number, {
          modelValue: this.selectedChargeValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.selectedChargeValue) = $event)),
          precision: 2,
          step: 0.1,
          max: 100,
          min: 1
        }, null, 8, ["modelValue", "step"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_table, {
      data: this.users,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "firstName",
          label: "Vorname"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lastName",
          label: "Nachname"
        }),
        _createVNode(_component_el_table_column, {
          prop: "items",
          label: "Guthaben verwalten",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "danger",
              style: {"margin-left":"16px"},
              onClick: ($event: any) => (_ctx.openChargeDialog(scope.row, false)),
              circle: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Minus)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (!this.shownUserBalances.has(scope.row.id))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  style: {"margin-left":"16px"},
                  onClick: ($event: any) => (this.showAndRefreshCredit(scope.row.id)),
                  circle: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Hide)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (this.shownUserBalances.has(scope.row.id))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(this.shownUserBalances.get(scope.row.id)) + " €", 1))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "success",
              style: {"margin-left":"16px"},
              onClick: ($event: any) => (_ctx.openChargeDialog(scope.row, true)),
              circle: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}